export default __webpack_public_path__ + "static/media/Tune.eba12da7.png";